import { useState } from 'react'

import { Link } from '@/components'
import { useCountdown } from '@/hooks'
import { OtpRateLimitError } from '@/modules/errors'
import { OTP_RESEND_COOLDOWN_SECONDS } from '../constants'

interface ResendCodeLinkProps {
  onResend: () => Promise<void>
}

export const ResendCodeLink = ({ onResend }: ResendCodeLinkProps) => {
  const { secondsLeft, restart } = useCountdown(OTP_RESEND_COOLDOWN_SECONDS)
  const [isSending, setIsSending] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleFailure = (failure: Error) => {
    if (failure instanceof OtpRateLimitError) {
      restart(failure.retryAfterSeconds)
      return
    }
    setError(failure.message)
  }

  const resend = () => {
    setIsSending(true)
    setError(null)
    onResend()
      .then(() => restart(OTP_RESEND_COOLDOWN_SECONDS))
      .catch(handleFailure)
      .finally(() => setIsSending(false))
  }

  if (secondsLeft > 0) {
    return (
      <p className="text-sm text-muted-foreground tabular-nums">
        You can request a new code in {secondsLeft} s
      </p>
    )
  }

  return (
    <div className="flex flex-col items-center gap-1">
      <Link asChild>
        <button
          type="button"
          onClick={resend}
          disabled={isSending}
          className="text-sm font-medium"
        >
          Send a new code
        </button>
      </Link>
      {error && <p className="text-xs font-semibold text-red-500">{error}</p>}
    </div>
  )
}
